import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FileInterface, AdInterface, appState, StatusEnum } from '../../constants/app-state';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'arm-dropdown-block',
  templateUrl: './dropdown-block.component.html',
  styleUrls: ['./dropdown-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownBlockComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();

  public fileToUploadPrivate: FileInterface[] = null;

  constructor(private cd: ChangeDetectorRef) {
  }

  @Input()
  validSubscribe: Subject<boolean>;

  set fileToUpload(value: FileInterface[]) {
    this.fileToUploadPrivate = value;
    this.cd.detectChanges();
  }

  get fileToUpload(): FileInterface[] {
    return this.fileToUploadPrivate;
  }

  public checkFileUpload(): void {
    const files = appState.getValue().files.getValue();

    const index = files.findIndex(file => file.loadStatus === StatusEnum.notLoaded);

    this.validSubscribe.next(index >= 0);

    this.cd.detectChanges();
  }

  public handleFileInput(files: FileList) {

    if (!files || !files.length) { return; }

    const appStateCopy = appState.getValue();

    const checkedFiles = Array.from(files).map(item => {
      return {
        value: item,
        loadStatus: StatusEnum.notLoaded,
      }
    });

    this.validSubscribe.next(true);

    appStateCopy.files.next([...appStateCopy.files.getValue(), ...checkedFiles]);
  }

  public ngOnInit(): void {

    if (!appState.getValue().ad) {
      const appStateCopy = appState.getValue();

      appStateCopy.ad = new BehaviorSubject<AdInterface>({
        heading: '',
      });

      appState.next(appStateCopy);

    }

    const appStateCopy = appState.getValue();

    if (!appStateCopy.files) {
      appStateCopy.files = new BehaviorSubject<FileInterface[]>([]);
    }

    this.subscriptions.add(
      appState.getValue().files
        .subscribe((files: FileInterface[]) => {
          this.fileToUpload = files;

          if (!files || !files.length) {
            this.validSubscribe.next(false);
          }

          this.checkFileUpload();
        })
    );

  }

  public ngOnDestroy(): void {

    appState.getValue().progressBar.next({
      show: false,
      value: 0,
    });

    this.subscriptions.unsubscribe();

  }

}
